/**
 * Format a time in seconds to a human-readable format
 * @param seconds - The time in seconds
 * @returns The formatted time in the format "HH:MM:SS"
 */

export const formatTime = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;
  
  if (hours > 0) {
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  } else {
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  }
};

/**
 * Format cycle time (stored in minutes) for display next to step title.
 * @param minutes - Cycle time in minutes (e.g. 2.5)
 * @returns e.g. "2m 30s" or "" if invalid
 */
export const formatCycleTime = (minutes: number | undefined | null): string => {
  if (minutes == null || minutes < 0 || !Number.isFinite(minutes)) return "";
  const totalSeconds = Math.round(minutes * 60);
  const m = Math.floor(totalSeconds / 60);
  const s = totalSeconds % 60;
  if (m === 0 && s === 0) return "";
  if (s === 0) return `${m}m 0s`;
  return `${m}m ${s}s`;
};